import { render } from "./PefComponent.vue?vue&type=template&id=45171349"
import script from "./PefComponent.vue?vue&type=script&lang=js"
export * from "./PefComponent.vue?vue&type=script&lang=js"

import "./PefComponent.vue?vue&type=style&index=0&id=45171349&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__